import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const registerRoutePredicate = ({ currentUser, defaultRoute, }) => {
    if (isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return { isSuccess: false, navigateTo: appRoutes.login() };
    }
    if (!currentUser) {
        return { isSuccess: true };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: false, navigateTo: appRoutes.verifyEmail() };
    }
    return {
        isSuccess: false,
        navigateTo: defaultRoute,
    };
};
